import React from 'react';
import { Calculator } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';
import { DevisPrestationComposer } from './DevisPrestationComposer';

/**
 * Estimation rapide d'un devis, pour l'équipe : on compose les prestations, on ajoute l'adresse pour les frais
 * kilométriques, éventuellement une formule, et on voit le prix pour le client. Rien n'est enregistré tant que
 * l'on n'a pas cliqué sur « Établir officiellement le devis » (le module « Devis » reste réservé aux vrais devis).
 */
export function EstimationDevisPage() {
    const { user } = useAuth();
    const [session, setSession] = React.useState(0);
    const companyName = (user as any)?.company_name || (user as any)?.companyName || (user as any)?.name || '';
    const logoUrl = (user as any)?.logoUrl || (user as any)?.logo_url || null;

    return (
        <div className="p-6 max-w-6xl mx-auto space-y-5">
            <div>
                <h1 className="text-xl font-black text-content flex items-center gap-2.5">
                    <Calculator size={22} className="text-brand-600 dark:text-brand-400" /> Estimation rapide
                </h1>
                <p className="text-sm text-content-muted mt-1">Chiffrez en quelques clics ce que coûterait une prestation à un client, sans créer de client ni de devis.</p>
            </div>
            <DevisPrestationComposer
                key={session}
                estimation
                companyName={companyName}
                logoUrl={logoUrl}
                onSent={() => setSession((n) => n + 1)}
                onReset={() => setSession((n) => n + 1)}
            />
        </div>
    );
}
